export default __webpack_public_path__ + "static/Mont-SemiBoldItalic-988e2df44cd7d22ea1959113910754f4.otf";